import React, { useMemo, useState } from 'react';
import { connect } from 'react-redux';
import cn from 'classnames';
import FullWidthModal from '@components/common/Modal/FullWidthModal';
import ModalHeader from '@components/common/ModalHeader/index';
import { TouchableButton } from '@components/common/Touchable/index';
import { ReactComponent as TipCheckMark } from '@assets/images/tipCheckMark.svg';
import { toWords } from 'number-to-words';
import { safeJsonParse } from '@utility/helperFunction';
import { LABEL, CUSTOM_MESSAGES } from '../../veriables';
import Style from './viewreceipt.module.scss';
import { TouchableDiv } from '../../components/common/Touchable';
import { urlSearchParams } from '@utility/utills';
import style from './viewreceipt.module.scss';

const UnifiedTipWarningPopup = props => {
  const {
    isOpen,
    onClose,
    onSubmitTips,
    setErrorPopUp,
    serverAppTheme,
    tipAmount,
    totalAmountForTip,
    isLandScape,
    showCheckSeat,
    handleDisplayCheckNumber,
    moreSeats,
    checkAndSeats
  } = props;

  const seat = safeJsonParse(window.sessionStorage.getItem('seat'), {});

  const [selectedOption, setSelectedOption] = useState('');

  const checkDecimal = val => {
    const newValdata = val.toString().split('.');
    if (newValdata[1]) {
      const newstr = newValdata[1].substring(0, 1);
      if (Number(newstr) > 0) {
        return Number(val)?.toFixed(1);
      } else {
        return newValdata[0];
      }
    }
    return val;
  };

  const tipPercents = checkDecimal(
    ((Number(tipAmount) / (totalAmountForTip || 1)) * 100)?.toFixed(1)
  );

  function formatAmount(amount) {
    if (amount == null || isNaN(amount)) return '';
    const fixedAmount = Number(amount).toFixed(2);
    const [dollars, cents] = fixedAmount.split('.');
    const dollarWords = titleCase(toWords(Number(dollars)));
    const centWords =
      cents === '00' ? 'Zero' : titleCase(toWords(Number(cents)));
    return `${dollarWords} Dollars and ${centWords} Cents`;
  }

  function titleCase(str) {
    return str
      .split(' ')
      .map(w => w.charAt(0).toUpperCase() + w.slice(1))
      .join(' ');
  }

  const popUpModal = useMemo(() => {
    const okButton = {
      backgroundColor: serverAppTheme?.secondaryBtn,
      color: '#ffff',
      border: 'none',
      borderRadius: '8px',
    };
    return { okButton };
  }, [serverAppTheme]);

  const formattedTipAmount = tipAmount ? Number(tipAmount)?.toFixed(2) : '0.00';

  const tipOptions = [
    {
      id: 'KEEP',
      label: `Leave a Tip of $${formattedTipAmount}`,
      description: `${formatAmount(tipAmount)} which is a ${tipPercents}%`,
      route: onSubmitTips,
    },
    {
      id: 'CHANGE',
      label: 'Change my Tip',
      description: 'Enter a different amount',
      route: () => onClose(false),
    },
  ];

  const handleContinue = () => {
    if (!selectedOption) {
      setErrorPopUp({ res: 'Please make a selection', noErrorTxt: true });
      return;
    }
    const selected = tipOptions.find(item => item.id === selectedOption);
    selected?.route();
  };

  return (
    <FullWidthModal
      isOpen={isOpen}
      customClass2={cn('w-100 h-100 position-relative')}
      style={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        height: '100%',
        pointerEvents: 'auto',
        backgroundColor: serverAppTheme?.popUp_bg,
        backgroundClip: 'padding-box',
        border: '0',
        boxShadow: serverAppTheme?.popUp_box_shadow,
      }}
    >
      <div
        className="col-12 px-0 justify-content-center align-items-center position-relative text-center h-100"
        style={popUpModal.primaryTextColor}
      >
        <div
          className={cn(
            'col-12 px-0 fs_18 align-items-center justify-content-center fw-600 h-100'
          )}
        >
          <ModalHeader
            stationName={seat?.stationName}
            tileHeader=""
            seatNumber={seat?.number}
            isTipWarning={true}
          />
          {showCheckSeat() && (
                  <TouchableDiv
                    className={cn('col-12 px-12',
                      ['11'].includes(urlSearchParams('screenType')) && isLandScape
                        ? style.checkht
                        : [
                          isLandScape ? style.landscapecheckht : style.checkht,
                          isLandScape ? (['33', '16'].includes(urlSearchParams('screenType')) ? "pt-1" : "pt-1 mt-1 pb-10") : "pt-2"
                        ].join(" ")
                    )}
                    onClick={e => {
                      e.preventDefault();
                    }}
                  >
                    <div
                      className={cn(
                        'col-12 fs_12 fs-12 fw-400 d-flex justify-content-between h-100 rounded align-items-center'
                      )}
                      style={{ background: serverAppTheme?.checkDetail_tabs }}
                    >
                      <div className={cn("col-6 text-left p-0", isLandScape ? 'h-80' : ' h-50')}>
                        Check {handleDisplayCheckNumber(checkAndSeats?.stage?.id)}
                      </div>
                      <div
                        className={cn('col-6 text-right pr-0', style.scrollableText, isLandScape ? 'h-80' : ' h-50')}
                      >
                        Seat {moreSeats}
                      </div>
                    </div>
                  </TouchableDiv>
                )}
          <div
            className={cn(
              "align-items-center d-flex fs_24 fw-600 h-85 text-center",
              isLandScape
                ? 'col-8 m-auto '
                : ''
            )}
          >
            <div className="col-12">
              <div className="fs_24 fw-600 pb-2">{CUSTOM_MESSAGES()?.GENEROUS_TIP}</div>
              <div className="fs_20 fw-400 pb-24">{CUSTOM_MESSAGES()?.TIP_SELECTION}</div>
              <div>
                {tipOptions.map(item => (
                  <div
                    key={item.id}
                    className={cn('d-flex align-items-center fs_16 p-3 mb-3')}
                    style={{
                      borderRadius: '8px',
                      border:
                        selectedOption === item.id
                          ? '1px solid #253382'
                          : '1px solid #D5D5D5',
                      background: '#FFF',
                      cursor: 'pointer',
                    }}
                    onClick={() => setSelectedOption(item.id)}
                  >
                    <div
                      className="d-flex align-items-center justify-content-center"
                      style={{ minWidth: '24px' }}
                    >
                      {selectedOption === item.id ? (
                        <TipCheckMark />
                      ) : (
                        <div
                          className={cn(Style.amountContainer)}
                        />
                      )}
                    </div>
                    <div className="text-left pl-3">
                      <div className="fw-600">{item.label}</div>
                      <div className="fw-400 fs_14">{item.description}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div
            className={cn(
              'col-12 d-flex justify-content-center position-absolute pb-3'
            )}
            style={{ bottom: '0' }}
          >
            <div
              className={cn(
                "pl-1 pr-0",
                isLandScape ? 'col-4' : 'col-6'
              )}
            >
              <TouchableButton
                type="submit"
                className={cn(
                  'od-primary-btn-bg-color od-primary-btn-font-color col-12 btn-ripple btn-lg',
                  isLandScape
                    ? 'btn44'
                    : 'btn68'
                )}
                style={{
                  background: serverAppTheme?.secondaryBtn,
                  color: serverAppTheme?.btn_font_color,
                }}
                onClick={e => {
                  e.stopPropagation();
                  e.preventDefault();
                  handleContinue();
                }}
                rippleEffect={true}
              >
                <div className={cn('fs_28 fw-600')}>
                  {LABEL().TIPS_CONTINUE}
                </div>
              </TouchableButton>
            </div>
          </div>
        </div>
      </div>
    </FullWidthModal>
  );
};

const mapStateToProps = state => ({
  serverAppTheme: state.theme.serverAppTheme,
});

export default connect(mapStateToProps)(UnifiedTipWarningPopup);
